import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/beach-bandits/result_img.webp";

function Resultbeach() {
  return (
    <section
      className="result_beach"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-md-6"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#63CB51" }}>Results</span>
            </h2>
            <p>
              With beach bandits, we have created an app that will change what
              it means to go to the beach. The personalized experience and
              amazing features like getting your beach accessories delivered to
              your specified location while you are at the beach is what sets
              beach bandits apart.
            </p>
            <p>
              It is truly a user-facing mobile app that serves the beach lovers.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultbeach;
